import { useContext, useEffect, useState } from "react";

import i18next from "i18next";
import classNames from "classnames";
import { shallowEqual, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, matchPath } from "react-router";
import { Form, InputGroup } from "react-bootstrap";
import { Navbar, Nav, FormControl } from "react-bootstrap";

import { getDashboardData } from "../../../app/features/dashboard/actions/dashboard";
import useReportGridName from "../../../app/features/reportDashboard/useReportGridName";
import { getLocationsByCountry } from "../../../app/common/actions/userDetails";
import { fetchLinerNameByCountry } from "../../../app/features/registration/actions/Registration";
import { updateDashbaordRefresh } from "../../../app/common/components/DataTable/slices/DataTable";
import { updateLinerDataCountry, updateSelectedPort } from "../../../app/common/slices/userDetails";
import { setMappingTopSearchFilter } from "../../../app/features/customerMappingDashboard/MappingSlice";
import {
  updateSelectedAmount,
  updateSelectedRowsInvoice,
} from "../../../app/features/multiBlPayment/slices/multiBlPaymentSlice";
import {
  updateBlTopSearchState,
  updateInvoiceTopSearchState,
  updateSearchInputValueNT,
  updateTopSearchFilter,
  updatePrevSearchInput,
  updateInstructionTopSearchState,
  updateUserTopSearchState,
  updateLinerId,
  updateReportTopSearchState,
  updatePaymentTopSearchState,
} from "../../../app/common/slices/navbarTop";
import {
  updateCurrentPageBlDashboard,
  updateCurrentPageInvoiceDashboard,
  updateCurrentPageInstructionDashboard,
  updateCurrentPageUserDashboard,
  updateCurrentPagePayment,
  updateCurrentPageEmailDashboard,
  updateCurrentPageReportDashboard,
  clearDashboards,
} from "../../../app/features/dashboard/slices/dashboardSlice";

import Logo from "../../common/Logo";

import { navbarBreakPoint, topNavbarBreakpoint } from "../../../config";

import AppContext from "../../../context/Context";

import {
  AESDecryptAny,
  AESEncrypt,
  AESEncryptAny,
} from "../../../encrypt-util";

import {
  useBlDashName,
  useInstDashName,
  useInvDashName,
} from "../../../hooks/useDashName";

import TopNavRightSideNavItem from "./TopNavRightSideNavItem";

const NavbarTop = () => {
  const dispatch = useDispatch();
   const storedUserCountry =
    AESDecryptAny(window.localStorage.getItem("@user-selected-datacountry")) || [];
    const profileDetails = useSelector((state) => state.userProfile.profile);
      const linerDataCountry = useSelector(
    (state) => state.userProfile.linerDataCountry
  );
  const storedCountry =
    storedUserCountry?.[0]?.loginId === profileDetails.email
      ? storedUserCountry?.[0]?.country
      : null;
  const dataCountry = storedCountry
    ? storedCountry
    : linerDataCountry
      ? linerDataCountry
      : profileDetails.partnerCountry || null;
  const searchInputValue = useSelector(
    (state) => state.navbarTop.searchInputValue
  );
  const locationAccess = useSelector(
    (state) => state.userProfile?.data?.response?.data?.list?.flatMap(item => item?.locationAccess || []) ?? [],
    shallowEqual
  );


  const { reportGridName, reportGridSortState } = useReportGridName();
  const prevSearchInput = useSelector(
    (state) => state.navbarTop.prevSearchInput
  );
  const { t } = useTranslation()
  const generateHeaderLabel = (s) => {
    let count = 1;
    for (let i in s) {
      if (s.charAt(i) === s.charAt(i).toUpperCase()) {
        count++;
      }
    }
    return count ? `resource_${count}:${s}` : s;
  };
  const selectedDashbaordName = useSelector(
    (state) => state.navbarTop.selectedDashbaordName
  );
  const location = useLocation();
  const selectedTopSearchFilter = useSelector(
    (state) => state.navbarTop.selectedTopSearchFilter
  );
  const [prevPathName, setPrevPathName] = useState("/home");
  //const [language, setLanguage] = useState("")
  const linerCountryList = useSelector(
    (state) => state.userProfile.countryList
  );
  const locationList = useSelector(
    (state) => state.userProfile.locationList
  );
  const grids = useSelector((state) => state.dataTable.grids);
  const invoiceGrids = useSelector((state) => state.dataTable.invoiceGrids);
  const instructionsGrids = useSelector(
    (state) => state.dataTable.instructionsGrids
  );
  const userGrids = useSelector((state) => state.dataTable.userGrids);
  const payorGrids = useSelector((state) => state.dataTable.payorGrids);
  const customerCodeGrids = useSelector((state) => state.dataTable.customerCodeGrids);
  const paymentGrids = useSelector((state) => state.dataTable.paymentGrids);
  const emailTemplateGrids = useSelector((state) => state.dataTable.emailTemplateGrids);
  const receiptGrids = useSelector((state) => state.dataTable.receiptGrids);
  const emailGrids = useSelector((state) => state.dataTable.emailGrids);
  const getInGetOutGrids = useSelector(
    (state) => state.dataTable.getInGetOutGrids
  );
  const mappingGrids = useSelector((state) => state.dataTable.mappingGrids);
  const sezGrids = useSelector((state) => state.dataTable.sezGrids);
  const docManagmentGrids = useSelector((state) => state.dataTable.docManagmentGrids);
  const reportGrids = useSelector((state) => state.dataTable.reportGrids);
    const reportList = useSelector(
      (state) => state.reportDashboard.reportList
    );
  const getGirdList = (gridName, gridWhere, sorts) => {
    dispatch(
      getDashboardData({
        gridName: gridName,
        payload: {
          fields: [],
          filters: {},
          size: 20,
          sorts: [`${sorts}`],
          page: 1,
        },
        dataCountry: dataCountry,

        partnerId:
          profileDetails.partnerType === "customer"
            ? profileDetails.partnerId
            : null,
        parameter:
          selectedTopSearchFilter?.where !== ""
            ? {
              searchParameter: searchInputValue.trim(),
              searchWhere: selectedTopSearchFilter?.where,
            }
            : {},
        where: AESEncrypt(gridWhere) || {},
      })
    );
  };

  const getSearchFilterList = (values) => {
    console.log("valuess",values)
    const searchFilter = values?.[0]?.searchFilter;
    let searchFilterList = [];

    if (searchFilter) {
      searchFilterList = JSON.parse(searchFilter);
    }
    return searchFilterList;
  };

  const instDashboardName = useInstDashName();
  const invDashboardName = useInvDashName();
  const blDashboardName = useBlDashName();

  const searchFilterList = getSearchFilterList(
    selectedDashbaordName === "BL_DASHBOARD_CUSTOMER"
      ? grids
      : selectedDashbaordName === "BL_DASHBOARD_LINER"
        ? grids
        : selectedDashbaordName === "INVOICE_DASHBOARD_CUSTOMER"
          ? invoiceGrids
          : selectedDashbaordName === "INVOICE_DASHBOARD_LINER"
            ? invoiceGrids
            : selectedDashbaordName === "INSTRUCTION_DASHBOARD_CUSTOMER"
              ? instructionsGrids
              : selectedDashbaordName === "INSTRUCTION_DASHBOARD_LINER"
                ? instructionsGrids
                : selectedDashbaordName === "USER_DASHBOARD"
                  ? userGrids
                    : selectedDashbaordName === "BL_REQUEST"
                      ? payorGrids
                        : selectedDashbaordName === "CUSTOMER_CODE_DASHBOARD"
                      ? customerCodeGrids
                  : selectedDashbaordName === reportGridName
                    ? reportGrids
                                 : selectedDashbaordName === "INVOICE_DETAILS_VN"
                    ? reportGrids
                                   : selectedDashbaordName === "FASAH_PAY_REPORT"
                    ? reportGrids
                                   : selectedDashbaordName === "DELIVERY_ORDER_REPORT"
                    ? reportGrids
                                   : selectedDashbaordName === "DO_EXTENSION_REPORT"
                    ? reportGrids
                                    : selectedDashbaordName === "AGENT_NOMINATION_REPORT"
                    ? reportGrids
                                     : selectedDashbaordName === "DETENTION_DEMURRAGE_REPORT"
                    ? reportGrids
                                     : selectedDashbaordName === "PAYMENT_DASHBOARD_REPORT"
                    ? reportGrids
                    : selectedDashbaordName === "PAYMENT_DASHBOARD"
                      ? paymentGrids
                      : selectedDashbaordName === "TEMPLATE_EMAIL_DASHBOARD"
                        ? emailTemplateGrids
                        : selectedDashbaordName === "PAYMENT_RECEIPT"
                          ? receiptGrids
                          : // : selectedDashbaordName === 'EMAIL_TEMPLATE_DASHBOARD'
                          selectedDashbaordName === "EMAIL_LOGS"
                            ? emailGrids
                            : selectedDashbaordName === "GATE_DASHBOARD_CUSTOMER"
                              ? getInGetOutGrids
                              : selectedDashbaordName === "CUSTOMER_DASHBOARD"
                                ? mappingGrids:
                                selectedDashbaordName === "SEZ_DASHBOARD" ||
                                selectedDashbaordName === "sez_cert_req_detail"
                                ? sezGrids:
                                selectedDashbaordName === "DOCUMENT_MST_DASHBOARD"
                                ? docManagmentGrids
                                : []
  );

  const param =
    '{"' +
    selectedTopSearchFilter?.id +
    '": ["' +
    searchInputValue.trim() +
    '"]}';
console.log("selectedDashbaordName",param)
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const getGridName = () => {
    if (location.pathname === `${APP_PATH_PREFIX}/home`) {
      return blDashboardName;
    } else if (location.pathname === `${APP_PATH_PREFIX}/payment`) {
      return invDashboardName;
    } else if (location.pathname === `${APP_PATH_PREFIX}/instruction`) {
      return instDashboardName;
    } else if (location.pathname === `${APP_PATH_PREFIX}/report`) {
      // return (dataCountry == 'VN') ?'INVOICE_DETAILS_VN':reportGridName;
      return reportGridName;

    } else if (location.pathname === `${APP_PATH_PREFIX}/paymentDashboard`) {
      return "PAYMENT_DASHBOARD";
    } else if (location.pathname === `${APP_PATH_PREFIX}/receipt`) {
      return "PAYMENT_RECEIPT";
    } else if (location.pathname === `${APP_PATH_PREFIX}/emailDashboard`) {
      // return 'EMAIL_TEMPLATE_DASHBOARD';
      return "EMAIL_LOGS";
    } else if (location.pathname === `${APP_PATH_PREFIX}/gateinout`) {
      return "GATE_DASHBOARD_CUSTOMER";
    } else if (location.pathname === `${APP_PATH_PREFIX}/mappingdashboard`) {
      return "CUSTOMER_DASHBOARD";
    } else if (location.pathname === `${APP_PATH_PREFIX}/sezDashboard`) {
      return "sez_cert_req_detail";
    } else return null;
  };

  const [linerData, setLinerData] = useState([]);

  const getSortOrder = () => {

    // const reportGridSort =
    //   dataCountry === "VN"
    //     ? "inv_no desc" :
    //     dataCountry === "SA"
    //       ? "inv_no desc"
    //       : dataCountry === "TZ"
    //         ? "do_number desc"
    //         : "bl_no desc";

    const reportGridSort = reportGridSortState ?? "bl_no desc";



    if (location.pathname === `${APP_PATH_PREFIX}/home`) return "lastupdateddate desc";
    if (location.pathname === `${APP_PATH_PREFIX}/payment`) return "blid asc";
    if (location.pathname === `${APP_PATH_PREFIX}/instruction`) return "timestamp desc";
    if (location.pathname === `${APP_PATH_PREFIX}/users`) return "user_id desc";
    if (location.pathname === `${APP_PATH_PREFIX}/report`) return reportGridSort;
    if (location.pathname === `${APP_PATH_PREFIX}/paymentDashboard`) return "pmtmode desc";
    if (location.pathname === `${APP_PATH_PREFIX}/receipt`) return "receipt_id desc";
    if (location.pathname === `${APP_PATH_PREFIX}/emailDashboard`) return "email_logs_id desc";
    if (location.pathname === `${APP_PATH_PREFIX}/gateinout`) return "bl_id desc";
    if (location.pathname === `${APP_PATH_PREFIX}/mappingdashboard`) return "id desc";
    if (location.pathname === `${APP_PATH_PREFIX}/sezDashboard`) return "id desc";

    return null;
  };

  const getGridWhere = (
    grids,
    invoiceGrids,
    instructionsGrids,
    userGrids,
    customerCodeGrids,
    reportGrids,
    paymentGrids,
    emailTemplateGrids,
    getInGetOutGrids,
    mappingGrids,
    docManagmentGrids,
    sezGrids
  ) => {
    if (location.pathname === `${APP_PATH_PREFIX}/home`) return grids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/payment`) return invoiceGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/instruction`)
      return instructionsGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/users`) return userGrids?.[0]?.whereClause;
        if (location.pathname === `${APP_PATH_PREFIX}/customerCode`) return customerCodeGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/report`) return reportGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/paymentDashboard`)
      return paymentGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/emailTemplate`) return emailTemplateGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/documentManagment`) return emailTemplateGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/receipt`) return receiptGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/emailDashboard`)
      return emailGrids?.[0]?.whereClause;
    if (location.pathname === `${APP_PATH_PREFIX}/gateinout`)
      return getInGetOutGrids?.[0]?.whereClause;
    if (location.pathname == `${APP_PATH_PREFIX}/mappingdashboard`)
      return mappingGrids?.[0]?.whereClause;
    if (location.pathname == `${APP_PATH_PREFIX}/sezDashboard`)
      return sezGrids?.[0]?.whereClause;
    if (location.pathname == `${APP_PATH_PREFIX}/documentManagment`)
      return docManagmentGrids?.[0]?.whereClause;
    return null;
  };
  const gridName = getGridName();

  const gridWhere = getGridWhere(
    grids,
    invoiceGrids,
    instructionsGrids,
    userGrids,
    customerCodeGrids,
    reportGrids,
    paymentGrids,
    emailTemplateGrids,
    receiptGrids,
    emailGrids,
    emailTemplateGrids,
    getInGetOutGrids,
    mappingGrids,
    docManagmentGrids,
    sezGrids
  );
  const gridSort = getSortOrder();

  useEffect(() => {
    const isPathValid =
      location.pathname === `${APP_PATH_PREFIX}/home` ||
      location.pathname === `${APP_PATH_PREFIX}/payment` ||
      location.pathname === `${APP_PATH_PREFIX}/instruction` ||
      location.pathname === `${APP_PATH_PREFIX}/report` ||
      location.pathname === `${APP_PATH_PREFIX}/paymentDashboard` ||
      location.pathname === `${APP_PATH_PREFIX}/receipt` ||
      location.pathname === `${APP_PATH_PREFIX}/emailDashboard` ||
      location.pathname === `${APP_PATH_PREFIX}/gateinout` ||
      location.pathname === `${APP_PATH_PREFIX}/mappingdashboard` ||
      location.pathname === `${APP_PATH_PREFIX}/sezDashboard`;
    const isPrevPathValid =
      prevPathName === `${APP_PATH_PREFIX}/home` ||
      prevPathName === `${APP_PATH_PREFIX}/payment` ||
      prevPathName === `${APP_PATH_PREFIX}/instruction` ||
      prevPathName === `${APP_PATH_PREFIX}/report` ||
      prevPathName === `${APP_PATH_PREFIX}/paymentDashboard` ||
      prevPathName === `${APP_PATH_PREFIX}/receipt` ||
      prevPathName === `${APP_PATH_PREFIX}/emailDashboard` ||
      prevPathName === `${APP_PATH_PREFIX}/gateinout` ||
      prevPathName === `${APP_PATH_PREFIX}/mappingdashboard` ||
      prevPathName === `${APP_PATH_PREFIX}/sezDashboard`;

    if (isPathValid && isPrevPathValid) {
      if (gridName /* && gridWhere && gridSort */) {
        if (prevSearchInput) getGirdList(gridName, gridWhere, gridSort);
        dispatch(updateBlTopSearchState({}));
        dispatch(updateInvoiceTopSearchState({}));
        dispatch(updateInstructionTopSearchState({}));
        dispatch(updateUserTopSearchState({}));
        dispatch(updateSearchInputValueNT(""));
        
          dispatch(updateReportTopSearchState());
      }
    }
    dispatch(updatePrevSearchInput(searchInputValue.trim()));
    setPrevPathName(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    dispatch(updateTopSearchFilter(searchFilterList[0]));
  }, [JSON.stringify(searchFilterList)]);

  const handleFilterChange = (e) => {
    const selectedId = e.target.value;
    const selectedFilter = searchFilterList.find(
      (option) => option.id === selectedId
    );

    if (selectedFilter) {
      dispatch(updateTopSearchFilter(selectedFilter));
      dispatch(setMappingTopSearchFilter(""));
    }
  };

  const _updateSearchInputValue = (e) => {
    if (!e.target.value) {
      if (location.pathname === `${APP_PATH_PREFIX}/home`) {
        dispatch(updateBlTopSearchState({}));
      } else if (location.pathname === `${APP_PATH_PREFIX}/payment`) {
        dispatch(updateInvoiceTopSearchState({}));
      } else if (location.pathname === `${APP_PATH_PREFIX}/instruction`) {
        dispatch(updateInstructionTopSearchState({}));
      } else if (location.pathname === `${APP_PATH_PREFIX}/users`) {
        dispatch(updateUserTopSearchState({}));
      } else if (location.pathname === `${APP_PATH_PREFIX}/report`) {
        dispatch(updateReportTopSearchState({}));
      } else if (location.pathname === `${APP_PATH_PREFIX}/paymentDashboard`) {
        dispatch(updatePaymentTopSearchState({}));
      } else if (location.pathname === `${APP_PATH_PREFIX}/mappingdashboard`) {
        dispatch(setMappingTopSearchFilter(""));
      } else if (location.pathname === `${APP_PATH_PREFIX}/sezDashboard`) {
        dispatch(updateUserTopSearchState({}));
      }
    }
    if (
      searchInputValue.trim() &&
      !e.currentTarget.value &&
      gridName /*  && gridWhere */
    ) {
      dispatch(updateDashbaordRefresh(true));
    }
    dispatch(updateSearchInputValueNT(e.target.value));
  };

  const {
    config: { showBurgerMenu, navbarPosition, navbarCollapsed },
    setConfig,
  } = useContext(AppContext);
  const { pathname } = useLocation();
  const isChat = pathname.includes("chat");

  const [showDropShadow, setShowDropShadow] = useState(false);

 

  const handleBurgerMenu = () => {
    navbarPosition === "top" && setConfig("navbarCollapsed", !navbarCollapsed);

    (navbarPosition === "vertical" || navbarPosition === "combo") &&
      setConfig("showBurgerMenu", !showBurgerMenu);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  const partnerCountry = profileDetails.partnerCountry;
    const reportGridSort =
    dataCountry === "VN"
      ? "inv_no desc" :
      dataCountry === "SA"
      ? "inv_no desc"
      : dataCountry === "TZ"
        ? "do_number desc"
        : "bl_no desc";
  

  const linerId = useSelector((state) => state.navbarTop.linerId);
  const language = useSelector((state) => state.navbarTop.language);

  // console.log("language",language)

  // useEffect(() => {
  //   dispatch(updateLinerId('1'));
  // }, []);



  const selectedPort = useSelector((state) => state.userProfile.selectedPort);
  useEffect(() => {
    window.addEventListener("scroll", setDropShadow);
    return () => window.removeEventListener("scroll", setDropShadow);
  }, []);


  useEffect(() => {
    if (dataCountry && locationAccess.length > 0) {
      dispatch(getLocationsByCountry({
        country: dataCountry, 
        locationAccess: locationAccess
      }));
    }
  }, [dataCountry, locationAccess, dispatch]);

  useEffect(() => {
    const localLiner = AESDecryptAny(window.localStorage.getItem("liner_id"));
    if (
      localLiner &&
      linerData.length > 0 &&
      !linerData.find((i) => i && i.value == localLiner)
    ) {
      window.localStorage.setItem("liner_id", AESEncryptAny(linerData[0].value));
      dispatch(updateLinerId(linerData[0].value));
    }
  }, [linerData]);

  useEffect(() => {
    if (linerCountryList && linerCountryList.length == 1 && !storedCountry) {
      dispatch(
        updateLinerDataCountry(
          storedCountry ||
          linerCountryList[0]?.countryCode ||
          profileDetails.partnerCountry
        )
      );
      const userSelectedCountry = [
        {
          loginId: profileDetails.email,
          country:
            storedCountry ||
            linerCountryList[0]?.countryCode ||
            profileDetails.partnerCountry ||
            "",
        },
      ];
      window.localStorage.setItem(
        "@user-selected-datacountry",
        AESEncryptAny(JSON.stringify(userSelectedCountry))
      );
      i18next.changeLanguage(
        `${storedCountry ||
        linerCountryList[0]?.countryCode ||
        profileDetails.partnerCountry}_${language}`
      );
    }
  }, [linerCountryList, language]);


  const handleSearch = (event) => {
    if (event.key === "Enter") {
      dispatch(updateSearchInputValueNT(searchInputValue.trim()));
      if (searchInputValue.trim().length > 0) {
        if (matchPath(location.pathname, `${APP_PATH_PREFIX}/home`)) {
          dispatch(updateCurrentPageBlDashboard(1));
          dispatch(updateBlTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              grids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: blDashboardName,
                payload: {
                  //fields: SelectedViewFields?.fields || [],
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["lastupdateddate desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(grids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/report`)) {
          dispatch(updateCurrentPageReportDashboard(1));
          dispatch(updateReportTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              reportGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                // gridName: (dataCountry == 'VN')?'INVOICE_DETAILS_VN':reportGridName,
                gridName: reportGridName,
                payload: {
                  //fields: SelectedViewFields?.fields || [],
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: [reportGridSortState],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(reportGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/payment`)) {
          dispatch(updateCurrentPageInvoiceDashboard(1));
          dispatch(updateInvoiceTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              invoiceGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: invDashboardName,
                payload: {
                  //fields: SelectedViewFields?.fields || [],
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["blid asc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(invoiceGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/instruction`)) {
          dispatch(updateCurrentPageInstructionDashboard(1));
          dispatch(updateInstructionTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              instructionsGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: instDashboardName,
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["timestamp desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(instructionsGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/users`)) {
          dispatch(updateCurrentPageUserDashboard(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              userGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "USER_DASHBOARD",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["user_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(userGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/customerCode`)) {
            dispatch(updateCurrentPageUserDashboard(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              customerCodeGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "CUSTOMER_CODE_DASHBOARD",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["customer_mapping_request_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(customerCodeGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        
        }  
        else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/exportBlDashboard`)) {
          dispatch(updateCurrentPageUserDashboard(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              userGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "BL_REQUEST",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["bl_request_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(payorGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        
        }
        else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/paymentDashboard`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              paymentGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "PAYMENT_DASHBOARD",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["pmtmode desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(paymentGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        }
        else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/emailTemplate`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              emailTemplateGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "TEMPLATE_EMAIL_DASHBOARD",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["email_template_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(emailTemplateGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        }
        else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/emailDashboard`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              emailGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "EMAIL_LOGS",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["email_logs_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(emailTemplateGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        }
        else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/mappingdashboard`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          dispatch(setMappingTopSearchFilter(searchInputValue.trim()));
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/sezDashboard`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          dispatch(
            getDashboardData({
              gridName: "sez_cert_req_detail",
              payload: {
                fields: [],
                filters:
                  selectedTopSearchFilter?.where == "" ? JSON.parse(param) : {},
                size: 20,
                sorts: ["sez_cert_req_id desc"],
                page: 1,
              },
              dataCountry: dataCountry,
              parameter:
                selectedTopSearchFilter?.where !== ""
                  ? {
                    searchParameter: searchInputValue.trim(),
                    searchWhere: selectedTopSearchFilter?.where,
                  }
                  : {},
              where: AESEncrypt(sezGrids?.[0]?.whereClause) || {},
              partnerId: profileDetails.partnerId,
            })
          );
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/receipt`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              receiptGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "PAYMENT_RECEIPT",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["receipt_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(receiptGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/emailDashboard`)) {
          // dispatch(updateCurrentPagePayment(1));
          dispatch(updateCurrentPageEmailDashboard(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              emailGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                // gridName: 'EMAIL_TEMPLATE_DASHBOARD',
                gridName: "EMAIL_LOGS",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["email_logs_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(emailGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/gateinout`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));

          dispatch(
            getDashboardData({
              gridName: "GATE_DASHBOARD_CUSTOMER",
              payload: {
                fields: [],
                filters:
                  selectedTopSearchFilter?.where == "" ? JSON.parse(param) : {},
                size: 20,
                sorts: ["bl_id desc"],
                page: 1,
              },
              dataCountry: dataCountry,
              parameter:
                selectedTopSearchFilter?.where !== ""
                  ? {
                    searchParameter: searchInputValue.trim(),
                    searchWhere: selectedTopSearchFilter?.where,
                  }
                  : {},
              where: AESEncrypt(getInGetOutGrids?.[0]?.whereClause) || {},
              partnerId: profileDetails.partnerId,
            })
          );
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/receipt`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              receiptGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "PAYMENT_RECEIPT",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["receipt_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(receiptGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/emailDashboard`)) {
          // dispatch(updateCurrentPagePayment(1));
          dispatch(updateCurrentPageEmailDashboard(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              emailGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                // gridName: 'EMAIL_TEMPLATE_DASHBOARD',
                gridName: "EMAIL_LOGS",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["email_logs_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(emailGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        } else if (matchPath(location.pathname, `${APP_PATH_PREFIX}/gateinout`)) {
          dispatch(updateCurrentPagePayment(1));
          dispatch(updateUserTopSearchState(JSON.parse(param)));
          if (
            (profileDetails?.partnerType === "customer" &&
              profileDetails?.partnerId &&
              getInGetOutGrids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            dispatch(
              getDashboardData({
                gridName: "GET_IN_OUT_DASHBOARD",
                payload: {
                  fields: [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? JSON.parse(param)
                      : {},
                  size: 20,
                  sorts: ["bl_id desc"],
                  page: 1,
                },
                dataCountry: dataCountry,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                      searchParameter: searchInputValue.trim(),
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
                where: AESEncrypt(getInGetOutGrids?.[0]?.whereClause) || {},
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
              })
            );
          }
        }
      } else {
        dispatch(setMappingTopSearchFilter(""));
        dispatch(updateDashbaordRefresh(true));
      }
    }
  };

  // useEffect(() => {
  //   if(locationList?.length > 0 && !selectedPort){
  //     dispatch(updateSelectedPort(locationList[0]?.portCode));
  //     // dispatch(updateDashbaordRefresh(true));
  //   }
  // }, [locationList,selectedPort]);
  
  useEffect(() => {
    if (
      profileDetails.partnerType !== "liner" &&
      profileDetails?.partnerCountry
    ) {
      dispatch(
        fetchLinerNameByCountry({
          country_code: profileDetails?.partnerCountry,
        })
      ).then((returnedData) => {
        setLinerData(returnedData?.payload);
        dispatch(
          updateLinerId(
            AESDecryptAny(window.localStorage.getItem("liner_id"))
              ? AESDecryptAny(window.localStorage.getItem("liner_id"))
              : returnedData?.payload[0]?.value.toString()
          )
        );
      });
    } else {
      dispatch(
        updateLinerId(
          AESDecryptAny(window.localStorage.getItem("liner_id"))
            ? AESDecryptAny(window.localStorage.getItem("liner_id"))
            : profileDetails?.partnerId
        )
      );
    }
  }, [profileDetails?.partnerCountry]);
  return (
    <Navbar
      className={classNames("navbar-glass  fs--1 navbar-top sticky-kit", {
        "navbar-glass-shadow": showDropShadow && !isChat,
      })}
      expand={
        navbarPosition === "top" || navbarPosition === "combo"
          ? topNavbarBreakpoint
          : true
      }
    >
      <Navbar.Toggle
        className={classNames("toggle-icon-wrapper me-md-3 me-2", {
          "d-lg-none": navbarPosition === "top",
          [`d-${navbarBreakPoint}-none`]:
            navbarPosition === "vertical" || navbarPosition === "combo",
        })}
        as="div"
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </Navbar.Toggle>

      <Logo at="navbar-top" width={100} id="topLogo" />

      <Nav navbar className={`flex-row align-items-center`} as="ul">
        {!(profileDetails?.partnerType === "liner") ? (
          <Nav.Item
            as="li"
            className="flex-row align-items-center justify-content-start"
          >
            <InputGroup>
              <InputGroup.Text
                className="rounded-pill-l bg-100 fs--1"
                style={{ fontWeight: 450 }}
              >
                {t('resource_1:carrier')}
              </InputGroup.Text>
              {linerData.length > 1 ? (
                <Form.Select
                  aria-label="Carrier"
                  className="rounded-pill-r text-primary fs--1"
                  size="md"
                  value={linerId}
                  onChange={(e) => {
                    const value = e.target.value;
                    dispatch(updateLinerId(value));
                    localStorage.setItem(`liner_id`, value);
                    dispatch(clearDashboards());
                    dispatch(updateSelectedRowsInvoice([]));
                    dispatch(updateSelectedAmount([]));
                  }}
                >
                  {linerData.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.text}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <InputGroup.Text
                  className="rounded-pill-r text-primary fs--1"
                  style={{
                    fontWeight: 450,
                    backgroundColor: "rgb(249, 250, 253)",
                  }}
                >
                  {linerData.length === 1 && linerData[0].text}
                </InputGroup.Text>
              )}
            </InputGroup>
          </Nav.Item>
        ) : (
          <Nav.Item
            as="li"
            className="flex-row align-items-center justify-content-start"
          >
            {linerCountryList?.length > 1 ? (
              <InputGroup>
                <InputGroup.Text
                  className="rounded-pill-l bg-100 fs--1"
                >
                  {t("resource_1:country")}
                </InputGroup.Text>
                <Form.Select
                  aria-label="Country"
                  className="rounded-pill-r text-primary fs-0"
                  size="md"
                  onChange={(e) => {
                    dispatch(updateLinerDataCountry(e.target.value));
                    dispatch(clearDashboards());
                    const userSelectedCountry = [
                      {
                        loginId: profileDetails.email,
                        country: e.target.value || "",
                      },
                    ];
                    window.localStorage.setItem(
                      "@user-selected-datacountry",
                      AESEncryptAny(JSON.stringify(userSelectedCountry))
                    );
                    i18next.changeLanguage(`${e.target.value}_${language}`);
                  }}
                  value={dataCountry}
                >
                  {linerCountryList?.map((option) => (
                    <option
                      key={option.countryCode}
                      value={option?.countryCode}
                    >
                      {option?.countryName}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            ) : (
              <></>
            )}
          </Nav.Item>
        )}

        <Nav.Item
          as="li"
          className="flex-row align-items-center justify-content-start ps-3"
        >
          {locationList?.length > 0 && profileDetails?.partnerType === "liner" ? (
            <InputGroup className="h-100">
              <InputGroup.Text
                className="rounded-pill-l bg-100 fs--1"
              >
                {t("resource_1:location")}
              </InputGroup.Text>
              <Form.Select
                aria-label="Location"
                className="rounded-pill-r text-primary fs-0"
                size="md"
                onChange={(e) => {
                  dispatch(updateSelectedPort(e.target.value));
                  // dispatch(updateDashbaordRefresh(true));
                }}
                value={selectedPort ?? ""}
              >
                <option value="" hidden={locationList.length<=1}>ALL</option>
                {locationList?.map((option) => (
                  <option
                    key={option.portCode}
                    value={option.portCode}
                  >
                    {option.portName}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          ) : (
            <></>
          )}
        </Nav.Item>
        <Nav.Item
          style={{ maxWidth: '25rem' }}
          className="ps-3 flex-row align-items-center justify-content-start"
        >
          {searchFilterList?.length > 0 ? (
            <InputGroup className=" g-0">
              <div className="col-5">
                <Form.Select
                  aria-label="Carrier"
                  className="rounded-pill-l bg-100 fs--1 h-100"
                  onChange={handleFilterChange}
                  value={selectedTopSearchFilter?.id}
                >
                  {searchFilterList?.map((option) => (
                    <option
                      className="text-dark"
                      key={option.id}
                      value={option.id}
                    >
                      {t(generateHeaderLabel(option.id))}
                    </option>
                  ))}
                </Form.Select>
              </div>

              <div className="col-7">
                <FormControl
                  type="search"
                  className="rounded-pill-r text-primary fs-0 shadow-none"
                  placeholder={t("resource_1:searchPlaceHolder")}
                  onChange={_updateSearchInputValue}
                  onKeyDown={handleSearch}
                  value={searchInputValue}
                />
              </div>
            </InputGroup>
          ) : (
            <></>
          )}
        </Nav.Item>
      </Nav>



      <TopNavRightSideNavItem />
    </Navbar>
  );
};

export default NavbarTop;
